module.exports = __webpack_public_path__ + "img/406fec1.jpg";